import styles from './Pages.module.css';

import Logo from '../components/Logo';

type Props = {
  loading: boolean;
};

const WelcomePage = ({ loading }: Props) => {
  return (
    <div
      className={styles.welcomePageWrapper}
      style={{
        opacity: loading ? 1 : 0,
        transition: !loading ? 'opacity .1s' : undefined,
        pointerEvents: !loading ? 'none' : undefined,
      }}
    >
      <div className={styles.welcomePageIconWrapper}>
        <Logo noTransition={true} />
      </div>
    </div>
  );
};

export default WelcomePage;
